
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.929 12.025"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7116","d":"M6.478.363L6.79 0H3.384L0 3.901h3.434zM4.249 3.902h6.432L8.933 1.868 7.466.162 5.249 2.739zM.041 4.52l6.395 6.729L3.378 4.52zm10.834 0H4.056l3.39 7.458.022.047 3.23-7.112zM8.5 11.239l6.385-6.719h-3.332zm6.426-7.338l-3.385-3.9h-3.4l3.355 3.9z","fill":"#dc9543"}})])
          )
        }
      }
    